import { Menu, MenuItems } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';
import React, { ReactNode } from 'react';

interface Props {
    children?: ReactNode;
    className?: string;
}

const MenuTW = ({ children, className }: Props) => (
    <Menu
        as="div"
        className={twMerge(
            'menu-item shadow-base absolute end-0 mt-1 inline-block w-max rounded-sm bg-white p-3 dark:bg-gray-200 dark:hover:bg-gray-300',
            className,
        )}
    >
        <MenuItems static={true}>{children}</MenuItems>
    </Menu>
);

export default MenuTW;
